import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { track } from '../lib/analytics';

export default function CTA() {
  return (
    <section className="relative border-t border-[rgba(201,162,75,0.10)]">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-5 sm:px-6 lg:px-12 py-12 lg:py-16 lg:py-24">
        <div className="relative overflow-hidden rounded-md border border-[#d8b34a]/30 bg-gradient-to-b from-[#13110a] to-[#0c0c0e] p-12 lg:p-16">
          <div className="absolute -top-32 -right-32 w-[400px] h-[400px] rounded-full bg-[#d8b34a]/[0.08] blur-3xl pointer-events-none" />
          <div className="relative grid grid-cols-1 lg:grid-cols-[1.4fr_1fr] gap-10 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 border gold-border rounded-sm">
                <ShieldCheck size={12} className="gold-text" strokeWidth={1.8} />
                <span className="text-[10px] tracking-[0.2em] font-mono gold-text">RISK-FIRST AUTOMATION</span>
              </div>
              <h2 className="font-display mt-6 text-3xl sm:text-4xl md:text-5xl font-bold leading-[1.05] text-white">
                Ready to start
                <br />
                <span className="gold-text">your free beta?</span>
              </h2>
              <p className="mt-5 text-[#CDBE94] leading-relaxed max-w-xl">
                Sign up free, connect your Alpaca paper account, and let Talas handle the execution discipline. No live funds used during beta.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <Link
                to="/signup"
                data-testid="cta-signup-btn"
                onClick={() => track('sign_up_click', { source: 'cta_section' })}
                className="group inline-flex items-center justify-center gap-2 px-7 py-4 bg-[#d8b34a] text-black font-semibold text-sm rounded-sm hover:bg-[#e6c365] transition-colors"
              >
                Sign Up Free
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </Link>
              <p className="text-[11px] text-[#A99563] mt-2 text-center">
                Free during beta · Paper trading only · Cancel anytime
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
